import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=960f5de2"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports